 <template>
  <div class="info-region-container">
    <div class="all-content-container" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>审批模板</h4>
          <el-button type="primary" class="adduser" @click="add"
            >添加</el-button
          >
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="审批标题：">
            <el-input
              v-model="formInline.title"
              clearable
              placeholder="请输入审批标题"
              maxlength="20"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" class="button" @click="onSubmit"
              >查询</el-button
            >
            <el-button type="button" ass="button" @click="resetBth"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table
            :data="tableData"
            align="center"
            class="data-table"
            style="width: 100%"
            v-loading="loading"
            :header-cell-style="{ background: '#F4F5F7' }"
          >
            <el-table-column
              fixed
              prop="title"
              align="center"
              label="审批标题"
              width
            ></el-table-column>
            <el-table-column
              prop="approveUserNames"
              align="center"
              label="审批环节"
              width
            ></el-table-column>

            <el-table-column fixed="right" align="center" label="操作" width>
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row.id, 'edit')"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="delApproveTemplate(scope.row.id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination
              background
              layout="prev, pager, next,jumper"
              class="pageTap"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pagesize"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <!-- 添加
        -->
        <el-dialog
          :title="dialogTitle"
          :visible.sync="centerDialogVisible"
          width="600px"
          center
          :before-close="resetForm"
        >
          <div class="info-content-container info-content-container-add">
            <el-form
              :inline="true"
              :model="dialogformInline"
              :rules="dialogRules"
              ref="dialogformInline"
              class="demo-form-inline"
            >
              <el-form-item label="审批标题：" label-width="100px" prop="title">
                <el-input
                  class="dialogformInline el-dailog_width"
                  v-model="dialogformInline.title"
                  placeholder="请输入审批标题"
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <p class="node_left">审批环节：</p>
              <div
                class="dialogfrom"
                v-for="(item, index) in noneList"
                :key="index"
                style="padding-left: 16px !important; padding-top: 9px"
              >
                <el-form-item style="margin-left: 40px">
                  <span class="indexcount">{{ index + 1 }}</span>
                  <el-select
                    v-model="noneList[index]"
                    clearable
                    placeholder="请选择审批环节"
                    class="input-icon_count"
                    style="width: 215px; margin-left: 10px"
                  >
                    <el-option
                      v-for="item in allSysUserList"
                      :key="item.id"
                      :label="item.username"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-button
                    type="button "
                    class="delbutton"
                    @click="delnode(index)"
                    >删除</el-button
                  >
                </el-form-item>
              </div>
            </el-form>
            <el-button type="text " class="addnode1" @click="addNode"
              >+添加审批环节</el-button
            >
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm">取消</el-button>
            <el-button type="primary" @click="submitForm()">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
 <<script>
 export default {
     name:'approvalTemplate',
     data() {
       return {
         value:'',
         allSysUserList:[],//查询所有用户
         editId:'',//详情id（查询详情时使用））
         id:'',
				list:[],//审批模板详情表(对象)
				remark:'',//备注
				title:'',//标题
				updateId:'',//创建修改人员id
				updateTime:'',//创建修改时间
           dialogTitle:'',
           pagesize:10,
           currentPage:1,
           total:0,
           loading:false,//加载
           centerDialogVisible:false,//添加弹框
           genderList:[{
               value:'0',
               name:'男',
           },{
                value:'1',
               name:'女',
           }
           ],

      formInline: {//查询条件（参数）
        title:''
        },
        dialogformInline:{//添加参数或者编辑参数
          title:'',
            role: '',// 角色
           nink:'',// 昵称
          organization:'' ,// 组织机构
          password:'',//密码
          userName:'',//姓名
          gender:'',//性别
          ipone:'',//手机号
          eamil:'',//邮箱
          qq:'',
 
        },
         dialogRules: { // 弹框表单验证
        title: [
          { required: true, message: "请输入审批标题",  trigger: "change" }
        ],
       
        },
        modelNoListData:[
            {
              label:'全部',
               id:-1,
            },
            {
              label:'管理员',
               id:0,
            },
            {
              label:'普通用户',
               id:1,
            },
            
        ],
        organizationList:[
              {
              label:'全部',
               id:-1,
            },
            {
              label:'武汉',
               id:0,
            },
            {
              label:'上海',
               id:1,
            },
        ],
       
          tableData: [],
        noneList:[],
        editId:''
  
      };
      
    
   
    },
 
  computed: {},
  created() {
     this.init()
  },
  mounted() {
   
  },
  methods:{
     // 重置
     resetForm() {
       this.centerDialogVisible=false;
        this.$refs['dialogformInline'].resetFields();
      },
       resetBth(){
         this.formInline.title=''  
         this.geTapproveTemplate()
       },
    //弹框里的数据
  delnode(index){
      this.noneList.splice(index,1);
 },
 init(){
          this.geTapproveTemplate()//列表信息
      },
 handleCurrentChange(currentPage){//下一页
      this.currentPage=currentPage
      this.geTapproveTemplate()//查询列表
},
      // 查询
onSubmit(){
         this.geTapproveTemplate()//查询列表
       },
//查询审批模板列表
geTapproveTemplate(){
  this.loading=true;//加载
          this.$api.system
          .geTapproveTemplate(
              this.currentPage,//第几页，默认1
              this.pagesize,//默认展示多少条，默认10
              this.formInline.title,//标题
              this.editId,//详情id（查询详情时使用）
              )
          .then((res)=>{
              if(res.code==200){
                  this.loading=false//关闭加载
                  this.total=res.count//
                  this.tableData=res.data;
              }else{
                  this.loading=false//关闭加载
                  this.$message.error(res.msg)
              }
          })
          .catch((err)=>{
              this.$message.error(err)
          })

 },
//删除审批模板
delApproveTemplate(id){
          this.$confirm("是否删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
          })
        .then(() => {
           this.$api.system
            .delfun(`/pc/approveTemplate/delApproveTemplate`, id)
            .then((res) => {
              if (res.code == 200) {
                this.geTapproveTemplate()//列表刷新
                this.$message ({
                    type:'success',
                    message:res.msg
                })
             }else{
              this.$message.error(res.msg)
             }
            });
         
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
   
},
add(){//添加（新增保存审批模板）
    this.editId=''
    this.dialogTitle='添加模板'
    this.noneList=[]//清空编辑时的数据
    this.centerDialogVisible=true;
    this.getAllSysUser()//查询所有用户
    this.empty()
},
 handleClick(id ,type){
        if(type=='edit'){
          this.editId=id
          this.dialogTitle='编辑';
          this.centerDialogVisible=true;
          this.getapproveTemplateEdit(id)//查询审批模板详情
          this.getAllSysUser()//查询所有用户

  }

    },
// 添加用户弹框确定
// centerDialogVisible(){
//         this.centerDialogVisible=false;
//          // 根据dialogTitle来判断是新增还是编辑
//          if (dialogTitle=='添加用户') {//新增用户
           
//          }
//     },
empty(){
      this.dialogformInline.title=""
      this.dialogformInline.role='';//清空
      this.dialogformInline.nink='';//清空
      this.dialogformInline.organization='';//清空
      this.dialogformInline.password='';//清空
      this.dialogformInline.userName='';//清空
      this.dialogformInline.gender='';//清空
      this.dialogformInline.ipone='';//清空
      this.dialogformInline.eamil='';//清空
      this.dialogformInline.qq='';//清空

    },
submitForm() { // 提交表单a
  if(this.dialogformInline.title ==''){
    this.$message.error('请输入审批标题')
  }else{
    if(this.dialogTitle=='添加模板'){//为添加新用户
      var arr=[];
      for(let i=0;i<this.noneList.length;i++){
        var obj={};
        obj.approveUserId=this.noneList[i]
        arr.push(obj)
      }
      this.addSaveApproveTemplate(arr,this.editId,this.dialogformInline.title)
    }else{//为编辑
      // var array=this.noneList.filter(function(item,index,array){ return  item !="null"});
      // var arr=[];
      // for (let index = 0; index < array.length; index++) {
      //   if(isNaN(array[index])){         
      //     for(let i=0; i<this.allSysUserList.length;i++){
      //       var val=this.allSysUserList
      //       if(val[i].username==array[index]){
      //         var obj={};
      //         obj.approveUserId= val[i].id
      //         arr.push(obj)
      //       }
      //     }
      //   }else{          
      //     for(let i=0;i<this.noneList.length;i++){
      //       var obj={};
      //       obj.approveUserId=this.noneList[i]
      //       arr.push(obj)
      //     }    
      //   }       
      // }
      // var arr1=[]
      // for(let i in arr){
      //   var obj={};
      //   if( !isNaN(arr[i].approveUserId)){
      //     obj.approveUserId= arr[i].approveUserId
      //     arr1.push(obj)
      //   }
      // }
      // console.log(arr1)
       var arr=[];
       for(let i=0;i<this.noneList.length;i++){
        var obj={};
        obj.approveUserId=this.noneList[i]
        arr.push(obj)
      }
      console.log(arr)

      this.addSaveApproveTemplate(arr,this.editId,this.dialogformInline.title)        
   }
  }
},
 cancellation(){//弹框取消时
        this.empty();
         this.$forceUpdate()
         this.centerDialogVisible=false;
    },
//添加保存审批模板(新增)
addSaveApproveTemplate(list,id,title){
  for(var i=0;i<list.length;i++) {
    if(list[i].approveUserId=="") {
      list.splice(i,1)
    }
  }
   this.loading=true;//开启加载
    this.$api.system
    .addSaveApproveTemplate(
         id,//编辑id
			   list,//审批模板详情表(对象)
				this.remark,//备注
				title,//标题
				this.updateId,//创建修改人员id
				this.updateTime,//创建修改时间
    )
    .then((res)=>{
      if (res.code==200) {
          this.centerDialogVisible=false;
        this.loading=false;//关闭加载
        this.geTapproveTemplate()//刷新列表
        this.$message({type:'success',message:res.msg})
       }else{
           this.centerDialogVisible=false;
         this.loading=false;//关闭加载
         //this.$message.error(res.msg)
       }
    })
},
//编辑列表数据接口
setApproveTemplate(){
      this.loading=true;//开启加载
      this.$api.system
      .setUserMessageList(

      )
      .then((res)=>{
        if (res.code==200) {
           this.loading=false;//关闭加载
           this.$meessage({type:'success',message:res.msg})
        }else{
          this.loading=false;//关闭加载
          this.$meessage.error(res.msg)
        }
      })
},
 //编辑时获取数据  查询审批模板详情
 getapproveTemplateEdit(id){
     this.loading=true;//开启加载
      this.$api.system
      .getapproveTemplateEdit(
          this.currentPage,//第几页，默认1
		      this.pagesize,//默认展示多少条，默认10
          id,//详情id（查询详情时使用））
				  this.formInline.title,//标题
      )
      .then((res)=>{
        if (res.code==200) {
           this.loading=false;//关闭加载
           this.dialogformInline.title=res.data.title;// 标题
              var arr=[]
              
            this.noneList= res.data.approveUserNames.split(",")
            console.log(this.noneList)
             for(var i =0;i< this.noneList.length;i++){
                 for(let j=0;j<this.allSysUserList.length;j++){
                    if(this.allSysUserList[j].id==this.noneList[i]){
                           arr.push(this.allSysUserList[j].id)
                      }
                   }
           }
          
           
           this.noneList=arr
           //对环节进行梳理
          //  this.noneList=res.data.approveUserNames.split("——")
          //  var arr=[]
          //  for(var i =0;i< this.noneList.length;i++){
          //   if(this.noneList[i]!="null"){
          //      arr.push(this.noneList[i])
          //   }
          //  }
          //  console.log(arr)
          //   this.noneList=arr
        }else{
          this.loading=false;//关闭加载
          this.$meessage.error(res.msg)
        }
      })
 },
 //查询所有用户
 getAllSysUser(){
   this.$api.system
      .getAllSysUser()
      .then((res)=>{
        if (res.code==200) {
           this.allSysUserList= res.data//所有用户
           
         }else{
          this.$meessage.error(res.msg)
        }
      })

 },
 //新增环节
 addNode(){
   this.noneList.push('')
     
 }
  
}
 };
 </script>
  <style scoped>
@import "../../style/approvalTemplate.scss";
.node_left {
  display: inline-block;
  position: absolute;
  left: 61px;
  top: 150px;
}
.addnode1 {
  margin-left: 113px;
  margin-top: 16px;
}
.dialogformInline {
  width: 320px;
}
.dialogfrom {
  height: 44px;
  width: auto;
  padding-left: 60px;
}
.delbutton {
  margin-left: 10px;
}
.indexcount {
  display: inline-block;
  height: 30px;
  width: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 50%;
  border: 1px solid #ccc;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  margin-right: 5px;
}
</style>